import { Link, useLocation } from "react-router-dom";
import { LayoutGrid, Sparkles, LineChart, Settings, Zap } from "lucide-react";

const NAV_ITEMS = [
  { href: "/content-hub",   label: "Content Hub",  icon: LayoutGrid },
  { href: "/ai-creator",    label: "AI Creator",   icon: Sparkles },
  { href: "/gsc-overview",  label: "GSC Overview", icon: LineChart },
  { href: "/settings",      label: "Settings",     icon: Settings },
];

export default function AppSidebar() {
  const { pathname } = useLocation();

  return (
    <aside className="w-[250px] flex-shrink-0 h-screen bg-white border-r border-gray-100 flex flex-col">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-indigo-600 flex items-center justify-center">
            <Zap size={14} className="text-white" />
          </div>
          <div>
            <p className="text-sm font-bold text-gray-900 leading-none">SEOWITH</p>
            <p className="text-[10px] text-gray-400 tracking-widest mt-0.5">SEO INTELLIGENCE</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV_ITEMS.map(({ href, label, icon: Icon }) => {
          const active = pathname === href || pathname.startsWith(href + "/");
          return (
            <Link
              key={href}
              to={href}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all ${
                active
                  ? "bg-indigo-50 text-indigo-700"
                  : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
              }`}
            >
              <Icon size={16} className={active ? "text-indigo-600" : "text-gray-400"} />
              {label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
